import { createInjectionKey as e } from "../../_utils/vue/create-injection-key.js";
const i = e("n-time-picker");
export {
  i as timePickerInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/time-picker/src/interface.js
// module id = 974
// module chunks = 67